export default "__VITE_ASSET__DTw7hCXG__"